module.exports = __webpack_public_path__ + "asset/image-Key-b2b7db6a2280ae19.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/Key.svg
// module id = w47J
// module chunks = 0